import React, { FC } from 'react'

//@ts-ignore
// import LKFetcherButton from 'shared/LKFetcherButton'
import { actions as DCActions } from '../../../DetailsContainer'

import translate from '../../translator'

import { BlockLoanButtonProps } from '../../types.LoanDetails'
import LKFetcherButton from 'src/features/shared/LKFetcherButtonNew'
import { loanBlock } from 'src/store/loan'

const BlockLoanButton: FC<BlockLoanButtonProps> = ({ type, ID, hash, disabled }) => (
  // <LKFetcherButton
  //   fetcherName={`Loan-${ID}-BlockLoan`}
  //   APICall={Loan.loanOper}
  //   disabled={disabled}
  //   params={{
  //     LoanID: ID,
  //     HashSum_LoanID_: hash,
  //     page: 'arrest',
  //   }}
  //   successCallbackActions={[DCActions.fetchPage({ type, ID, hash, page: 'base' })]}
  //   style={{ display: 'flex' }}
  //   alias="bullet_red"
  //   permission="LOAN_ARREST"
  // >
  //   {translate('cmd_arrest')}
  // </LKFetcherButton>

  //UPDATED API REQUEST loan_oper_api page: arrest
  <LKFetcherButton
    buttonAction={loanBlock}
    params={{
      LoanID: ID,
      HashSum_LoanID_: hash,
    }}
    actionName={`Loan-${ID}-BlockLoan`}
    disabled={disabled}
    successCallbackActions={[DCActions.fetchPage({ type, ID, hash, page: 'base' })]}
    style={{ display: 'flex' }}
    alias="bullet_red"
    permission="LOAN_ARREST"
  >
    {translate('cmd_arrest')}
  </LKFetcherButton>
)

export default BlockLoanButton
